// Contexto de configuración: feature flags efectivos para el usuario actual.
// Por defecto TODO desactivado, así la interfaz no cambia hasta que se active.
import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const DEFAULT_FEATURES = {
    personalMastery: false,
    lifeBalance: false,
    goals: false,
    values: false,
    habits: false,
    mindset: false,
    socialSkills: false,
    socialChallenges: false,
    conversationAI: false,
    leadershipAcademy: false,
    teamDevelopment: false,
    teamGrowthSimulator: false,
};

const ConfigContext = createContext(null);

export function ConfigProvider({ children }) {
    const { user } = useAuth();
    const [features, setFeatures] = useState(DEFAULT_FEATURES);
    const [ready, setReady] = useState(false);

    const load = useCallback(async () => {
        if (!user) {
            setFeatures(DEFAULT_FEATURES);
            setReady(true);
            return;
        }
        try {
            const { data } = await api.get("/config/features");
            setFeatures({ ...DEFAULT_FEATURES, ...(data.features || {}) });
        } catch {
            setFeatures(DEFAULT_FEATURES);
        } finally {
            setReady(true);
        }
    }, [user]);

    useEffect(() => {
        load();
    }, [load]);

    const anyDevEnabled = Object.values(features).some(Boolean);

    return (
        <ConfigContext.Provider value={{ features, ready, anyDevEnabled, reload: load }}>
            {children}
        </ConfigContext.Provider>
    );
}

export function useConfig() {
    const ctx = useContext(ConfigContext);
    if (!ctx) throw new Error("useConfig debe usarse dentro de ConfigProvider");
    return ctx;
}
